import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "hamburger", "hamburgerIcon", "closeIcon", "dropdown", "navLink"
  ]

  static values = { slimHeader: Boolean }

  connect() {
    this.hideMenuTitles()
    this.bindEventListeners()

    const wrapper = document.querySelector("#wrapper")
    if (this.slimHeaderValue) {
      wrapper.classList.add("h-[45px]")
    } else {
      wrapper.classList.add("h-[60px]")
    }
  }

  hideMenuTitles() {
    const hideables = document.querySelectorAll('.hideable')
    if (this.slimHeaderValue) {
      hideables.forEach(el => el.classList.add('md:hidden'))
    } else {
      hideables.forEach(el =>
        el.classList.add('md:hidden', 'lg:block', 'xl:block', '2xl:block')
      )
    }
  }

  bindEventListeners() {
    this.hamburgerTarget?.addEventListener("click", this.toggleMobileMenu)
    this.dropdownTargets?.forEach(el => {
      el.addEventListener("click", this.toggleDropdown)
    })
    window.addEventListener("click", this.closeDropdownsOnOutsideClick, true)

    this.navLinkTargets?.forEach(link => {
      link.addEventListener("click", this.closeMobileMenuOnLinkClick)
    })
  }

  toggleMobileMenu = (e) => {
    e.stopPropagation()
    const navMenu = document.querySelector("nav.menu-list")
    navMenu.classList.toggle("open")
    const expanded = navMenu.classList.contains("open")
    this.hamburgerTarget.setAttribute("aria-expanded", expanded)

    // Hide/show hamburger & close icons
    if (expanded) {
      document.querySelectorAll("nav .main-menu-dropdown.active")
        .forEach(el => el.classList.remove("active"))

      this.hamburgerIconTarget?.classList.add("hidden")
      this.closeIconTarget?.classList.remove("hidden")
    } else {
      this.hamburgerIconTarget?.classList.remove("hidden")
      this.closeIconTarget?.classList.add("hidden")
    }
  }

  toggleDropdown = function () {
    this.classList.toggle("active")
    this.setAttribute("aria-expanded", this.classList.contains("active"))
  }

  closeDropdownsOnOutsideClick = (event) => {
    document.querySelectorAll('.main-menu-dropdown').forEach(dropdown => {
      if (!dropdown.contains(event.target)) {
        dropdown.classList.remove("active")
        dropdown.setAttribute("aria-expanded", "false")
      }
    })
  }

  closeMobileMenuOnLinkClick = (e) => {
    if (window.innerWidth < 640) {
      const navMenu = document.querySelector("nav.menu-list")
      navMenu.classList.remove("open")
      this.hamburgerTarget.setAttribute("aria-expanded", "false")

      this.hamburgerIconTarget?.classList.remove("hidden")
      this.closeIconTarget?.classList.add("hidden")

      document.querySelectorAll(".main-menu-dropdown.active").forEach(dropdown => {
        dropdown.classList.remove("active")
        dropdown.setAttribute("aria-expanded", "false")
      })
    }
  }
}
